import { render } from "./CanvasMembers.vue?vue&type=template&id=3445f74f&scoped=true"
import script from "./CanvasMembers.vue?vue&type=script&lang=js"
export * from "./CanvasMembers.vue?vue&type=script&lang=js"

import "./CanvasMembers.vue?vue&type=style&index=0&id=3445f74f&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3445f74f"]])

export default __exports__